export enum ResultLevel {
    Low = "Low",
    Mid = "Mid",
    High = "High",
}
